function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 12C1 5.92487 5.92487 1 12 1H21C22.1046 1 23 1.89543 23 3V21C23 22.1046 22.1046 23 21 23H12C5.92487 23 1 18.0751 1 12Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 5C21 3.89543 20.1046 3 19 3L12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21H19C20.1046 21 21 20.1046 21 19V5ZM17.4 11.1H6.60001V12.9H17.4V11.1Z",
  fill: "#F2D95C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 5C21 3.89543 20.1046 3 19 3L12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21H19C20.1046 21 21 20.1046 21 19V5ZM17.4 11.1H6.60001V12.9H17.4V11.1Z",
  fill: "black",
  fillOpacity: 0.05
});

function SvgMaybeOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaybeOutline);
export default __webpack_public_path__ + "static/media/MAYBE_outline.5681f8d5.svg";
export { ForwardRef as ReactComponent };